import {OnboardingOrigin} from '@/bank/bank.types'

export type CheckExistingOnboardingCommand = {
    tenantId: string
}

export type InitiateOnboardingCommand = {
    tenantId: string,
    redirectUrl: string
}

export type CheckOnboardingStatusCommand = {
    tenantId: string,
    onboardingUuid: string
}

export type CancelOnboardingCommand = {
    tenantId: string,
    onboardingUuid: string
}

export enum OnboardingApiVersion {
    v1 = 'v1', v2 = 'v2'
}

export type Onboarding = {
    uuid: string,
    orgNo: string,
    tenantId: string,
    origin: OnboardingOrigin,
    apiVersion: OnboardingApiVersion,
    onboardingStatus: OnboardingStatus,
    /**
     * Will be removed in the future
     * @deprecated Use onboardingStatus
     */
    status: LegacyOnboardingStatus,
    providerOnboardingId?: string,
    providerOnboardingUrl?: string,
    providerOnboardingStatus?: string,
    /**
     * Will be removed in the future
     * @deprecated
     */
    activeSubscription?: boolean,
    completedAt?: Date,
    createdBy: string,
    createdAt: string
    version: number,
    /**
     * Will be removed in the future
     * @deprecated Use providerOnboardingId
     */
    flowId?: string,
    /**
     * Will be removed in the future
     * @deprecated Use providerOnboardingUrl
     */
    onboardingUrl?: string,
    /**
     * Will be removed in the future
     * @deprecated Use providerOnboardingStatus
     */
    flowStatus?: string
}

export enum LegacyOnboardingStatus {
    unknown = 'unknown', processing = 'processing', unsuccessful = 'unsuccessful',
    canceled = 'canceled', successful = 'successful', alreadyOnboarded = 'already_onboarded'
}

export enum OnboardingStatus {
    Created = 'Created', AwaitingCustomerAction = 'AwaitingCustomerAction', Processing = 'Processing',
    ManualHandling = 'ManualHandling', Accepted = 'Accepted', Rejected = 'Rejected',
    Cancelled = 'Cancelled', Unknown = 'Unknown'
}